<!--
 * @Author: wsx
 * @Date: 2022-01-11 16:21:19
 * @LastEditTime: 2022-02-14 10:33:28
 * @LastEditors: Please set LastEditors
 * @Description:面包屑
-->
<template>
  <el-breadcrumb class="LayoutBreadcrumb" separator="/">
    <template v-for="item in paths" :key="item.id">
      <el-breadcrumb-item>{{ item.name }}</el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>
<script >
import { defineComponent, reactive, toRefs, watch } from "vue";
import { useContext } from "@/hooks/core/useContext";
export default defineComponent({
  name: "LayoutBreadcrumb",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      paths: [],
    });
    const refData = toRefs(state);
    const layoutData = useContext("layoutData");
    watch(
      () => layoutData.paths,
      (v) => {
        state.paths = v;
      },
      { immediate: true, deep: true }
    );
    return { ...refData };
  },
});
</script>
<style  lang='scss' scoped >
.LayoutBreadcrumb {
  // padding: 10px 10px 0;
  // background-color: var(--el-color-white);
  // height: 30px;
  font-size: 12px !important;
  padding-left: 20px;
}
</style>